export default __webpack_public_path__ + "static/media/venmo.a965a42e.svg";